import { produce } from 'immer';

import { queryClient } from '../../shared/providers/react-query-provider';
import { getDossierQueryKey } from '../dossier/queries';
import { DossierId, SerializedDossier } from '../dossier/types';

import { getPreTripReviewsQueryKey } from './hooks';
import { NormalizedPreTripReview } from './types';

export const removePreTripReviewFromCache = (dossierId: DossierId) => {
    queryClient.setQueryData<NormalizedPreTripReview>(getPreTripReviewsQueryKey(), (cur) => {
        return produce(cur, (draft) => {
            if (!draft) return;
            delete draft[dossierId];
        });
    });

    queryClient.setQueryData<SerializedDossier>(getDossierQueryKey(dossierId), (cur) => {
        return produce(cur, (draft) => {
            if (!draft?.preTripReview) return;
            delete draft.preTripReview[dossierId];
        });
    });
};
